import React from 'react'
import cn from 'classnames'
import { TypeItemIconList, IconListFieldSize } from '../../../lib/types'
import { ContentProps } from '../../renderer'
import { FixedSpacer } from '../../ui-lib/spacer'
import { Typography } from '@grammarly/badger-ui'
import { IconListItem } from './icon-list-item'
import styles from './icon-list.module.scss'

const { T3 } = Typography

export const IconList: React.FC<ContentProps<TypeItemIconList>> = (props) => {
  const {
    structure: {
      fields: {
        title,
        icons,
        maxIconsPerRow = 2,
        iconSize = IconListFieldSize.Small,
        showAltTextUnderIcons,
        internalName,
      },
    },
  } = props

  if (!icons) {
    return null
  }

  const iconsPerRow = Math.min(icons.length, maxIconsPerRow)
  const iconSizeClasses = {
    [IconListFieldSize.Large]: styles.large,
    [IconListFieldSize.Small]: '',
  }

  return (
    <div data-component-id={internalName}>
      {title && (
        <>
          <T3 as="h3" className={styles.iconListTitle}>
            {title}
          </T3>
          <FixedSpacer multiplier={5} />
        </>
      )}
      <div
        className={cn(styles.iconsListWrapper, iconSizeClasses[iconSize])}
        style={{ '--desktopMaxIconsPerRow': iconsPerRow } as React.CSSProperties}
      >
        {icons.map((iconAsset) => (
          <IconListItem
            iconSize={iconSize}
            structure={iconAsset}
            key={`icon-list-${iconAsset.sys.contentType.sys.id}-${iconAsset.sys.id}`}
            showAltTextUnderIcon={showAltTextUnderIcons}
          />
        ))}
      </div>
    </div>
  )
}
